<button
  (click)="toggleSound()"
  mat-icon-button
  color="accent"
  aria-label="toggle sound button">
  <mat-icon *ngIf="soundOn">volume_up</mat-icon>
  <mat-icon *ngIf="!soundOn">volume_off</mat-icon>
</button>
